import Decimal from "decimal.js";
import qs from "qs";

// process.env.NODE_ENV !== "production" && (() => {
//   cookies.set('MALLagentId', '876564156398960640');
//   cookies.set('MALLaliasName', 'hk_shop');
// })();

const config = {
  // baseUrl: process.env.NODE_ENV === "production" ? 'http://api.mtremall.com' : 'http://testapi.mtremall.com',
  baseUrl:
    process.env.NODE_ENV === "production"
      ? "//api.mtremall.com"
      : "//api.mtremall.com",
  // baseUrl: process.env.NODE_ENV === "production" ? '//api.mtremall.com' : '//192.168.2.21:8888',
  // baseUrl: 'http://api.mtremall.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : '192.168.2.21:8888',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'oskastudiobeauty.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'potentialtraining.net',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'hiyori.mtremall.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'canvas.mtremall.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'greenproduction.mtremall.com',
  // DOMAIN_NAME:
  //   process.env.NODE_ENV === "production"
  //     ? window.location.host
  //     : "happy.mtremall.com",
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'acellencetrading.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'demoa.mtremall.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'bebricktoy.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'emthk.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : "hugesurplusltd.com",
  DOMAIN_NAME:
    process.env.NODE_ENV === "production"
      ? window.location.host
      : "happy.mtremall.com",
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'canvas.mtremall.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'demo.mtremall.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? 'luxuriant.mtremall.com' : 'demo.mtremall.com',
  // DOMAIN_NAME: process.env.NODE_ENV === "production" ? window.location.host : 'newextend.mtremall.com',
  // PAYMENT_HOST: 'https://testpay.mtremall.com/',
  PAYMENT_HOST: "//pay.mtremall.com/",
};

let mediaMatch = {
  isMdmax: window.matchMedia("(max-width:768px)").matches,
  isMds: window.matchMedia("(max-width:990px)").matches,
  isXl: window.matchMedia("(min-width:1280px)").matches,
  is1Xl: window.matchMedia("(min-width:1400px)").matches,
};

window.addEventListener("resize", (e) => {
  mediaMatch.isMdmax = window.matchMedia("(max-width:768px)").matches;
  mediaMatch.isXl = window.matchMedia("(min-width:1280px)").matches;
  mediaMatch.isXl = window.matchMedia("(min-width:1400px)").matches;
});

export function queryParse(obj) {
  return `?${qs.stringify(obj)}`;
}

export function getOrderStatus(status) {
  if (status === undefined || status === null) {
    return "无订单状态";
  }

  switch (status) {
    case 0:
      return "待付款";
    case 1:
      return "订单完成";
    case 2:
      return "待发货";
    case 3:
      return "待收货";
    case 4:
      return "待评价";
    case 8:
      return "待使用";
    case 9:
      return "订单取消";
    case -2:
      return "退款中";
    case -3:
      return "退款完成";
    case -4:
      return "已关闭";
    case -5:
      return "撤销申请";
    case 101:
      return "待成团";
    case 201:
      return "备货中";
    case 202:
      return "待付尾款";
    default:
  }
}

export function getSrc(url, meta) {
  return new URL(url, meta.url).href;
}

export function toFormData(data) {
  if (typeof data === "object") {
    let formData = new FormData();
    for (let i in data) {
      formData.append(i, data[i]);
    }
    return formData;
  } else {
    throw new Error("只有对象可以转换成Form Data，请检查传入的参数类型");
  }
}

/**
 * 是否为空对象
 * @param obj
 * @returns {boolean|*}
 */
export function isEmptyObj(obj) {
  if (typeof obj !== "object") {
    return obj;
  }
  if (obj === null) {
    return true;
  }
  return Object.keys(obj).length === 0;
}

/**
 * 深拷贝
 * @param value
 * @returns {{}|*}
 */
export function deepClone(value) {
  let res = {};

  if (Array.isArray(value)) {
    return value.map((child) => deepClone(child));
  }

  if (typeof value === "object" && typeof value !== null) {
    for (let i in value) {
      res[i] = deepClone(value[i]);
    }
    return res;
  }

  return value;
}

/**
 * 后两位精度处理
 * @type {{add: ((function(): (number|number))|*)}}
 */
const calc = {
  add: function () {
    let args = arguments;
    let res = new Decimal(0);
    let i = 0;
    if (args.length > 0) {
      for (; i < args.length; i++) {
        res = res.add(typeof args[i] === "string" ? Number(args[i]) : args[i]);
      }
    }
    // console.log(res.toFixed(2),'res');
    // res = Number(res.toFixed(2));
    if (isNaN(res)) {
      return 0;
    }
    return res.toFixed(2);
  },
};

export { config, mediaMatch, calc };
